import { QrCodeIcon } from "@heroicons/react/24/outline";
import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { FC } from "react";
import { IBoardingResult } from "../../interfaces/endpoints/IBoarding.types";
import ResultCard from "./ResultCard";

export type ShownScan =
  | { kind: "result"; value: IBoardingResult; shownAt: number }
  | { kind: "failed"; message: string; shownAt: number };

type Props = {
  shown: ShownScan | null;
  busy: boolean;
  undoing: boolean;
  onUndo: (attemptId: number) => void;
};

// Always mounted, so screen readers announce each new answer; dimmed while the next check runs so the
// previous passenger's card is never read as the current one.
const ResultSlot: FC<Props> = ({ shown, busy, undoing, onUndo }) => (
  <div
    aria-live="assertive"
    aria-atomic="true"
    aria-busy={busy}
    className={`min-h-[10rem] sm:min-h-[16rem] ${busy ? "opacity-40" : ""}`}
  >
    {shown?.kind === "result" && (
      <ResultCard
        key={shown.shownAt}
        result={shown.value}
        shownAt={shown.shownAt}
        onUndo={onUndo}
        undoing={undoing}
      />
    )}
    {shown?.kind === "failed" && (
      <div
        key={shown.shownAt}
        data-outcome="failed"
        className="flex items-center gap-3 rounded-lg bg-gray-700 p-4 text-white shadow-lg"
      >
        <ExclamationTriangleIcon aria-hidden className="h-10 w-10 shrink-0" />
        <span className="text-xl font-semibold">{shown.message}</span>
      </div>
    )}
    {!shown && (
      <div
        className="flex h-full min-h-[10rem] sm:min-h-[16rem] items-center justify-center rounded-lg border-2
          border-dashed border-gray-300"
      >
        <QrCodeIcon aria-hidden className="h-12 w-12 text-gray-300" />
      </div>
    )}
  </div>
);

export default ResultSlot;
